import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';
import { InputLabel } from './InputLabel';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    marginBottom: theme.marginBase,
    marginTop: theme.marginBase * 3,
  },
  list: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginRight: -theme.marginBase * 3,
  },
  verticalList: {
    flexDirection: 'column',
    flexWrap: 'no-wrap',
    alignItems: 'stretch',
  },
  checkbox: {
    marginBottom: theme.marginBase * 2,
    marginRight: theme.marginBase * 3,
    width: 'auto',
    maxWidth: '50%',
    flex: 1,
    minWidth: 250,
    [theme.media.mobile]: {
      maxWidth: '100%',
    },
  },
  verticalCheckbox: {
    maxWidth: '100%',
  },
  fullLine: {
    maxWidth: '100%',
  },
  noBottomMargin: {
    marginBottom: 0,
  },
  noMargin: {
    marginBottom: -theme.marginBase,
    marginTop: 0,
  },
}));

export interface CheckboxBlockListProps {
  label?: string | React.ReactNode;
  secondaryLabel?: string;
  children?: React.ReactNode[];
  noBottomMargin?: boolean;
  noMargin?: boolean;
  noCheckboxBottomMargin?: boolean;
  vertical?: boolean;
  fullLine?: boolean;
  checkboxClassName?: string;
  classNameList?: string;
  rightAction?: React.ReactNode;
}

export const CheckboxBlockList = ({
  label,
  secondaryLabel,
  children,
  noBottomMargin,
  noCheckboxBottomMargin,
  vertical,
  fullLine,
  noMargin,
  checkboxClassName,
  classNameList,
  rightAction,
}: CheckboxBlockListProps) => {
  const classes = useStyles();
  return (
    <div
      className={classnames(classes.container, {
        [classes.noBottomMargin]: noBottomMargin,
        [classes.noMargin]: noMargin,
      })}
    >
      <InputLabel
        label={label}
        rightAction={rightAction}
        secondaryLabel={secondaryLabel}
      />
      <div
        className={classnames(
          classes.list,
          {
            [classes.verticalList]: !!vertical,
          },
          classNameList,
        )}
      >
        {!!children &&
          children.map((child: React.ReactNode, index: number) => (
            <div
              key={index}
              className={classnames(
                classes.checkbox,
                {
                  [classes.noBottomMargin]: noCheckboxBottomMargin,
                  [classes.verticalCheckbox]: !!vertical,
                  [classes.fullLine]: !!fullLine,
                },
                checkboxClassName,
              )}
            >
              {child}
            </div>
          ))}
      </div>
    </div>
  );
};
